import { STORAGE_KEYS } from '../config/constants';

export interface StoredUser {
    id: string;
    name: string;
    email: string;
    role: string;
    nik?: string;
    employeeId?: string;
    cnaUserId?: string;
}

/**
 * Auth Storage
 * Wrapper simpel untuk LocalStorage, menangani Token & User Data.
 */
export const authStorage = {
    getAccessToken: (): string | null => {
        if (typeof window === 'undefined') return null;
        return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    },

    setAccessToken: (token: string): void => {
        if (typeof window === 'undefined') return;
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
    },

    getUser: (): StoredUser | null => {
        if (typeof window === 'undefined') return null;
        const userStr = localStorage.getItem(STORAGE_KEYS.USER);
        if (!userStr) return null;
        try {
            return JSON.parse(userStr);
        } catch {
            return null;
        }
    },

    setUser: (user: StoredUser): void => {
        if (typeof window === 'undefined') return;
        localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
    },

    clearTokens: (): void => {
        if (typeof window === 'undefined') return;
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
        localStorage.removeItem(STORAGE_KEYS.USER);
    },

    hasToken: (): boolean => {
        return !!authStorage.getAccessToken();
    },
};